// src/pages/NewChallenge.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import instance from '../../../api/axiosConfig';
import { useUser } from "../../../context/UserContext";
import Emojies from "../../../data/Emojies";

const NewChallenge = ({ closeModal, fetchChallenges }) => {
  const navigate = useNavigate();
  const { user, loginUser } = useUser(); // Use context
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    title: '',
    icon: '',
    totalDay: 0,
    startDate: '',
    isIncludedToday: false,
  });

  const validate = () => {
    const newErrors = {};
    if (!formData.title) newErrors.title = "Title is required";
    if (!formData.icon) newErrors.icon = "Icon is required";
    if (formData.totalDay <= 0) newErrors.totalDay = "Total days must be greater than 0";
    if (!formData.startDate) newErrors.startDate = "Start date is required";
    return newErrors;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
    // Xóa lỗi cho trường hiện tại
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: undefined,
    }));
  };
  const handleIconSelect = (icon) => {
    setFormData({
      ...formData,
      icon: icon,
    });
    setErrors((prevErrors) => ({
      ...prevErrors,
      icon: undefined,
    }));
  };
  const handleSave = async () => {
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    // Logic để lưu dữ liệu
    try {
      const responseData = await instance.post("/challenge", {
        userId: user.guid,
        title: formData.title,
        icon: formData.icon,
        start: formData.startDate,
        totalDay: formData.totalDay,
        includedToday: formData.isIncludedToday,
      });

      closeModal();
      fetchChallenges();
      // Lưu thông tin user hoặc JWT từ backend (nếu có)
    } catch (error) {
      console.error("Error sending token to backend:", error);
    }
  };

  return (
    <div className="">
      <h2 className="text-3xl font-bold mb-8 text-gray-800 text-center">Create New Challenge</h2>
      <form>
        {/* Title Field */}
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">Title</label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
            placeholder="Enter challenge title"
          />
          {errors.title && <p className="text-red-500 text-sm">{errors.title}</p>}
        </div>

        {/* Icon Field */}
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">Icon</label>
          <div className="flex flex-wrap gap-2 overflow-x-scroll">
            {Emojies.map((emoji, index) => (
              <div
                key={index}
                onClick={() => handleIconSelect(emoji)}
                className={`cursor-pointer p-2 border rounded-lg ${formData.icon === emoji ? 'border-blue-500' : 'border-gray-300'}`}
              >
                {emoji}
              </div>
            ))}
          </div>
          {errors.icon && <p className="text-red-500 text-sm">{errors.icon}</p>}
        </div>

        {/* Total Days Field */}
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">Total Days</label>
          <input
            type="number"
            name="totalDay"
            value={formData.totalDay}
            onChange={handleChange}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
            placeholder="Enter total days"
          />
          {errors.totalDay && <p className="text-red-500 text-sm">{errors.totalDay}</p>}
        </div>

        {/* Start Date Field */}
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">Start Date</label>
          <input
            type="date"
            name="startDate"
            value={formData.startDate}
            onChange={handleChange}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
          />
          {errors.startDate && <p className="text-red-500 text-sm">{errors.startDate}</p>}
        </div>

        {/* Include Today Checkbox */}
        <div className="mb-8">
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="isIncludedToday"
              checked={formData.isIncludedToday}
              onChange={handleChange}
              className="form-checkbox h-5 w-5 text-blue-500 rounded focus:ring-2 focus:ring-blue-500 transition-all"
            />
            <span className="ml-3 text-sm text-gray-700">Include Today</span>
          </label>
        </div>

        {/* Buttons */}
        <div className="flex justify-between">
          <button
            type="button"
            onClick={handleSave}
            className="bg-blue-500 text-white px-6 py-3 rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all"
          >
            Save
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="bg-gray-500 text-white px-6 py-3 rounded-lg hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition-all"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default NewChallenge;